import React from 'react'
import { useIntl } from 'react-intl'
import Skeleton from 'react-loading-skeleton'

const FinancialDetailsSkeleton = () => {
    const { formatMessage } = useIntl()
    return (
        <div className='bg-white w-100 border px-3 py-4 rounded mb-4'>
            <div className='d-flex flex-column justify-content-between'>
                <div className='d-flex mb-md-4 flex-column flex-md-row'>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Scenario Name' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Round Name' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Pre Money Valuation' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Convert Convertible Notes' })}</p>
                    </div>
                </div>
                <div className='d-flex flex-column flex-md-row'>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Invested by Existing Investors' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Invested by New Investors' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Unallocated' })}</p>
                    </div>
                    <div className='d-flex flex-column justify-content-md-start w-100'>
                        <Skeleton
                            width={'80%'}
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            className='mb-2'
                        />
                        <p className='font-size-13 text-muted m-0 mb-2'>{formatMessage({ id: 'Total Investment Amount' })}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FinancialDetailsSkeleton
